import React from 'react';
import Typography from '@mui/material/Typography';

import { Flex } from 'src/components/flex';

import reffieLogosBrainTransparent256 from 'src/assets/img/reffie-logos/brain-transparent-256.png';

export default function Logo() {
    return (
        <Flex justifyContent="center" alignItems="center">
            <img src={reffieLogosBrainTransparent256} alt="Reffie Logo" width={48} height={48} />
            <Typography fontSize={24} color="primary">Reffie</Typography>
        </Flex>
    );
}
